import axios from 'axios';

import { logger } from '@/utils/logger';
import type { TLogCategory } from '@/utils/logger/types';

export const handleError = (error: unknown, category: TLogCategory) => {
  if (!axios.isCancel(error)) {
    logger.error(error, category);
  }
};
